var featureToggleConfig = {
    "see::feature": ["button-account"],
};
export default featureToggleConfig;
